import { render, staticRenderFns } from "./IndividualCourseLectureRankingPage.vue?vue&type=template&id=01c90744&scoped=true"
import script from "./IndividualCourseLectureRankingPage.vue?vue&type=script&lang=js"
export * from "./IndividualCourseLectureRankingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c90744",
  null
  
)

export default component.exports